import type { Decision } from "../../api/types";
import { QuestionCard } from "../parts/QuestionCard";
import { texte } from "../../texte";

/** Rückfragen-Tab — Mensch-KI-Q&A, entspricht files/decisions.md im Workspace (client.md §9.3). */
export function Decisions({
  decisions,
  onAnswer,
}: {
  decisions: Decision[];
  onAnswer: (qid: string, text: string) => void;
}) {
  if (!decisions.length) {
    return (
      <div className="empty" style={{ maxWidth: 620 }}>
        {texte.decisions.empty}
      </div>
    );
  }
  return (
    <div className="feed" style={{ maxWidth: 660 }}>
      {decisions.map((d) => (
        <QuestionCard key={d.qid} decision={d} variant="tab" onAnswer={onAnswer} />
      ))}
    </div>
  );
}
